import { combineReducers, createSlice, type PayloadAction, type UnknownAction } from '@reduxjs/toolkit'

export interface PrintConfigState {
  expandPrintColumns: boolean
}

const initialPrintConfigState: PrintConfigState = {
  expandPrintColumns: true,
}

const printConfigSlice = createSlice({
  name: 'print-config',
  initialState: initialPrintConfigState,
  reducers: {
    toggleExpandPrintColumns: (state) => {
      state.expandPrintColumns = !state.expandPrintColumns
    },
  },
})

type MarketFilterState = {
  selectedUsages: string[]
  hiddenUsages: string[]
  showAllUsagesGroup: boolean
}

const initialMarketFilterState: MarketFilterState = {
  selectedUsages: ['UX-Roundtable'],
  hiddenUsages: ['bla'],
  showAllUsagesGroup: false,
}

const marketFilterSlice = createSlice({
  name: 'market-filter',
  initialState: initialMarketFilterState,
  reducers: {
    setSelectedGroup: (state, action) => {
      state.selectedUsages = action.payload
    },
    toggleShowAllGroups: (state) => {
      state.showAllUsagesGroup = !state.showAllUsagesGroup
    },
  },
})

interface SidebarChangesState {
  display: 'all' | 'recent' | 'accumulated'
}

const initialSidebarChangesState: SidebarChangesState = {
  display: 'all',
}

const sidebarChangesSlice = createSlice({
  name: 'sidebar-changes',
  initialState: initialSidebarChangesState,
  reducers: {
    setSidebarChangesDisplayMode: (state, { payload }: PayloadAction<SidebarChangesState['display']>) => {
      state.display = payload
    },
  },
})

export const localConfigSlice = combineReducers({
  printConfig: printConfigSlice.reducer,
  marketFilter: marketFilterSlice.reducer,
  sidebarChanges: sidebarChangesSlice.reducer,
})

const combinedActions = {
  ...printConfigSlice.actions,
  ...marketFilterSlice.actions,
  ...sidebarChangesSlice.actions,
}

const allActionsSet = new Set<string>(Object.values(combinedActions).map((action) => action.type))

export function isLocalConfigAction(action: UnknownAction): boolean {
  return allActionsSet.has(action.type)
}

export const { toggleExpandPrintColumns, setSelectedGroup, toggleShowAllGroups, setSidebarChangesDisplayMode } = combinedActions
export const localConfigAction = combinedActions
